"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Perception = void 0;
var Conversational_1 = require("./Conversational");
var PerceivedImpulse_1 = require("./PerceivedImpulse");
/**
 * This type contains all perception sensor impulses which are used to invoke
 * events in gaia.
 */
var Perception = /** @class */ (function (_super) {
    __extends(Perception, _super);
    function Perception() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "Perception";
        /**
         * Contains all perception fields needed for a conversation.
         */
        _this.conversational = function (config) { return _this.push(function (registry) {
            var entity = new Conversational_1.Conversational();
            config(entity);
            return "conversational { " + entity.render(registry) + " }";
        }); };
        /**
         * Data perception impulse used to invoke a data transformation behaviour
         */
        _this.perceiveData = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new PerceivedImpulse_1.PerceivedImpulse();
            config(entity);
            return "perceiveData(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        /**
         * Action perception impulse used to invoke a data transformation behaviour
         */
        _this.perceiveAction = function (impulse, config) { return _this.push(function (registry) {
            var name1 = registry.register("impulse", impulse);
            var entity = new PerceivedImpulse_1.PerceivedImpulse();
            config(entity);
            return "perceiveAction(impulse:" + name1 + "){" + entity.render(registry) + "}";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return Perception;
}(Array));
exports.Perception = Perception;
//# sourceMappingURL=Perception.js.map